module.exports = __webpack_public_path__ + "img/logo.fb6b0a36.svg";